export default "__VITE_ASSET__5MZiKmYo__"